export enum ParentChangedSurnameID {
  Madre = '1',
  Padre = '2',
}
